import { reqGetDictCacheMapByTypeToPost } from "../request/mtdsbase/internal/dict/getDictCacheMapByTypeToPost/post.js";
import { ref } from "vue-demi";
import { debounce } from "lodash-es";
const resultMap = new Map();
const resultPromiseMap = new Map();
const resolveMap = new Map();
const requestParams = [];
const axiosDict = async () => {
  const codes = [...requestParams];
  requestParams.length = 0;
  const res = await reqGetDictCacheMapByTypeToPost({ dictTypeList: codes });
  Object.keys(res).forEach((code) => {
    const dict = res[code];
    if (code === "ROOT_MARKET_DESIGN_SOURCE_TYPE") {
      dict.push({
        id: "",
        parentId: "",
        parentIds: "",
        value: "",
        label: "\u65E0\u8BBE\u8BA1\u6765\u6E90",
        code: "",
        type: "",
        description: "",
        sort: 0,
        platformType: "",
        remarks: "",
        effective: 1,
        extendAttr1: "",
        extendAttr2: "",
        extendAttr3: "",
        parentIdsName: ""
      });
    }
    const resolve = resolveMap.get(code);
    if (resolve) {
      resolve(dict);
      resolveMap.delete(code);
    }
    resultPromiseMap.delete(code);
    const result = resultMap.get(code);
    if (result) {
      if (!result.value) {
        result.value = dict;
      }
    } else {
      resultMap.set(code, ref(dict));
    }
  });
};
const debounceAxiosDict = debounce(axiosDict, 600);
async function getDict(code, effective) {
  let res;
  const result = resultMap.get(code);
  if (result == null ? void 0 : result.value) {
    res = result.value;
  } else {
    const resultPromise = resultPromiseMap.get(code);
    if (resultPromise) {
      res = await resultPromise;
    } else {
      const retPromise = resultPromiseMap.get(code);
      if (retPromise) {
        res = await retPromise;
      } else {
        requestParams.push(code);
        const promise = new Promise((resolve, reject) => {
          resolveMap.set(code, resolve);
        });
        resultPromiseMap.set(code, promise);
        debounceAxiosDict();
        res = await promise;
      }
    }
  }
  if (effective) {
    return res.filter((r) => r.effective);
  } else {
    return [...res];
  }
}
function getDictSync(code) {
  const result = resultMap.get(code);
  if (result)
    return result;
  const resolve = ref(null);
  resultMap.set(code, resolve);
  requestParams.push(code);
  debounceAxiosDict();
  return resultMap.get(code);
}
export { getDict, getDictSync };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getDict.js